import React from 'react'
import Card from '@mui/material/Card/index.js'
import CardContent from '@mui/material/CardContent/index.js'
import CardHeader from '@mui/material/CardHeader/index.js'

import CowCard from '../../CowCard/index.js'

import { moneyString } from '../../../utils/moneyString.js'
import { levelAchieved } from '../../../utils/levelAchieved.js'
import { getPlayerName } from '../../../utils/getPlayerName.js'
import { integerString } from '../../../utils/integerString.js'

const OnlinePeer = ({
  peer: { cowOfferedForTrade, dayCount, playerId, experience, money },
}: {
  peer: {
    cowOfferedForTrade: farmhand.cow | null
    dayCount: number
    playerId: string
    experience: number
    money: number
  }
}) => {
  return (
    <li>
      <Card>
        <CardHeader
          {...{
            title: getPlayerName(playerId),
            subheader: (
              <div>
                <p>Day: {integerString(dayCount)}</p>
                {/* TODO: Remove `?? 0` after 10/24 */}
                <p>Level: {integerString(levelAchieved(experience ?? 0))}</p>
                <p>Money: {moneyString(money)}</p>
              </div>
            ),
          }}
        />
        <CardContent>
          {cowOfferedForTrade && (
            <CowCard
              {...{
                cow: cowOfferedForTrade,
                isCowOfferedForTradeByPeer: true,
                isSelected: false,
              }}
            />
          )}
        </CardContent>
      </Card>
    </li>
  )
}

export default OnlinePeer
